import { render, staticRenderFns } from "./LsDragTable.vue?vue&type=template&id=639d245c&scoped=true"
import script from "./LsDragTable.vue?vue&type=script&lang=js"
export * from "./LsDragTable.vue?vue&type=script&lang=js"
import style0 from "./LsDragTable.vue?vue&type=style&index=0&id=639d245c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d245c",
  null
  
)

export default component.exports